import { ReactNode } from "react";

import DocumentationIconButton from "components/DocumentationIconButton";
import SearchInput from "components/SearchInput";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Button from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { getDocsUrl } from "utils/getDocsUrl";
import { AccountContext } from "views/AccountWrapper";
import DesktopView from "components/Mobile/DesktopView";
import MobileView from "components/Mobile/MobileView";
import useCanCreateWorkerPool from "shared/WorkerPool/access/useCanCreateWorkerPool";

import { FILTERS_ORDER_SETTINGS_KEY } from "./constants";

type WorkerPoolsPageLayoutProps = {
  children: ReactNode;
  onCreate?: () => void;
};

const WorkerPoolsPageLayout = ({ children, onCreate }: WorkerPoolsPageLayoutProps) => {
  const { accountName } = useTypedContext(AccountContext);
  const canCreateWorkerPool = useCanCreateWorkerPool();

  useTitle(`Worker pools · ${accountName}`);

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderWrapper>
          <ViewHeaderTitle>Worker pools</ViewHeaderTitle>
          <MobileView>
            {onCreate && (
              <Tooltip
                active={!!canCreateWorkerPool.message}
                on={(props) => (
                  <Button
                    {...props}
                    onPress={onCreate}
                    variant="primary"
                    disabled={!canCreateWorkerPool.result}
                  >
                    Create worker pool
                  </Button>
                )}
              >
                {canCreateWorkerPool.message}
              </Tooltip>
            )}
          </MobileView>
        </ViewHeaderWrapper>

        <ViewHeaderWrapper direction="row" directionMobile="column">
          <SearchInput
            placeholder="Search worker pools..."
            filtersOrderSettingsKey={FILTERS_ORDER_SETTINGS_KEY}
          />
          <DesktopView>
            <DocumentationIconButton
              href={getDocsUrl("/concepts/worker-pools")}
              tooltipText="Go to worker pools documentation"
            />

            {onCreate && (
              <Tooltip
                active={!!canCreateWorkerPool.message}
                on={(props) => (
                  <Button
                    {...props}
                    onPress={onCreate}
                    variant="primary"
                    disabled={!canCreateWorkerPool.result}
                  >
                    Create worker pool
                  </Button>
                )}
              >
                {canCreateWorkerPool.message}
              </Tooltip>
            )}
          </DesktopView>
        </ViewHeaderWrapper>
      </ViewHeader>
      {children}
    </>
  );
};

export default WorkerPoolsPageLayout;
